.extraLinks {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: var(--spacer-8);
}
